import React, { useEffect, useState } from "react";
import CustomerDeviceItem from "./CustomerDeviceItem";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { useCreateCustomerView, useEditViewSelectedDeviceId } from "../../hooks/useCloudSelectors";
import {
  changeEditViewState,
  setCustomersOnMap,
  changeCreateCustomerViewState,
  setSelectedSystems,
  setSelectedSensorSite,
} from "../../ducks/customersDuck";

import { Checkbox, Divider, Stack, Typography, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { styled, alpha } from "@mui/material/styles";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
import FactoryIcon from "@mui/icons-material/Factory";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
// import { triggerTrendShortPreLoad } from "../../../src/Dashboard/ducks/trendsDuck"; // DISABLED - preload endpoints no longer used
import { t } from "i18next";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CircleIcon from "@mui/icons-material/Circle";

// const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
//   color: theme.palette.grey[200],
//   [`& .${treeItemClasses.content}`]: {
//     borderRadius: theme.spacing(0.5),
//     padding: theme.spacing(0.5, 1),
//     margin: theme.spacing(0.2, 0),
//     [`& .${treeItemClasses.label}`]: {
//       fontSize: '0.8rem',
//       fontWeight: 500,
//     },
//   },
//   [`& .${treeItemClasses.groupTransition}`]: {
//     marginLeft: 15,
//     paddingLeft: 18,
//     borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
//   },
//   ...theme.applyStyles('light', {
//     color: theme.palette.grey[800],
//   }),
//}))

const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
  // color: theme.palette.grey[200],
  [`& .${treeItemClasses.content}`]: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.2, 0),
    [`& .${treeItemClasses.label}`]: {
      fontSize: "0.8rem",
      fontWeight: 500,
    },

    // Disable hover background
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },

    // Disable selected background
    [`&.Mui-selected, &.Mui-selected:hover`]: {
      backgroundColor: "transparent",
    },

    // Disable focus outline
    [`&.Mui-focused`]: {
      backgroundColor: "transparent",
    },
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginLeft: 15,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },

  ...theme.applyStyles("light", {
    color: theme.palette.grey[800],
  }),
}));

const CustomerWithDevicesList = ({ showIds, customers, selectedSystems, sensorManagementView }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const createCustomerVisible = useCreateCustomerView();
  const selectedDeviceId = useEditViewSelectedDeviceId();
  const isAdmin = location.pathname === "/admin";
  const theme = useTheme();

  const [expandedItems, setExpandedItems] = useState([]);

  const handleExpandedItemsChange = (event, itemIds) => {
    setExpandedItems(itemIds);
  };

  useEffect(() => {
    // Initialize expanded items based on the customers list
    const initialExpandedItems = customers.map((customer, idx) => customer.customerId + "-" + idx);
    setExpandedItems(initialExpandedItems);
  }, [customers]);

  const onSelectCustomer = (customer) => {
    dispatch(
      setCustomersOnMap({
        ...customer,
        onMap: !customer.onMap,
      })
    );
  };

  //handler to modify the visibility state of the edit view

  const editViewStateHandler = (payload) => {
    dispatch(changeEditViewState(payload));
  };

  //handler to modify visibility of the add new customer window

  const editCreateCustomerStateHandler = () => {
    if (!createCustomerVisible) dispatch(changeCreateCustomerViewState());
  };

  const onSelectDevice = (e, item, customer) => {
    // if in sensor management view, handle selected sensor site selection separately.
    // Use selectedSensorSite reduxstate, No need to trigger trend pre-load.
    if (sensorManagementView) {
      console.log("sensorManagementView is true, set sensorsite", item, customer);
      dispatch(
        setSelectedSensorSite({
          ...item,
          customerId: customer.customerId,
          customerName: customer.customerName,
        })
      );
      return;
    }

    // DISABLED - preload endpoints no longer used with new InfluxDB integration
    // dispatch(
    //   triggerTrendShortPreLoad({ systemId: item.deviceId, SiteId: customer.customerId, DeviceId: item.deviceId })
    // );
    const selectedDeviceItem = {
      ...item,
      customerId: customer.customerId,
      customerName: customer.customerName,
    };
    const id = item.deviceId;
    const isRemoving = selectedSystems.find((o) => o.deviceId === id);
    const selected = isRemoving && selectedSystems.filter((dev) => dev.deviceId !== id);
    const devices = isRemoving ? selected : [...selectedSystems, selectedDeviceItem];

    if (location.pathname === "/map") {
      dispatch(setSelectedSystems({ devices, path: "map" }));
    } else {
      dispatch(setSelectedSystems({ devices, path: "devices" }));
      localStorage.setItem("selectedSystems", JSON.stringify(devices));
    }
  };
  console.log("customers", customers);

  return (
    <Box sx={{ height: "100%", backgroundColor: theme.palette.background.paper }}>
      <SimpleTreeView
        expandedItems={expandedItems}
        onExpandedItemsChange={handleExpandedItemsChange}
      // onExpandedItemsChange={(newExpanded) => setExpandedItems(newExpanded)}
      // slots={{
      //   expandIcon: expandIcon,
      //   collapseIcon: collapseIcon,
      //   // endIcon: CloseSquare,
      // }}
      >
        {customers &&
          customers.map((customer, idx) => (
            <CustomTreeItem
              itemId={customer.customerId + "-" + idx}
              key={customer.customerId + "-" + idx}
              onClick={(e) => {
                e.stopPropagation();
                if (location.pathname === "/map") {
                  onSelectCustomer(customer);
                } else if (location.pathname === "/admin") {
                  editViewStateHandler(customer.customerName);
                }
              }}
              sx={{ marginBottom: theme.spacing(1) }}
              label={
                <>
                  <Stack
                    direction="row"
                    alignItems={"center"}
                    spacing={1}
                    sx={{
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      // backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    <FactoryIcon />
                    <Typography variant="subtitle2" color="text.secondary">
                      {customer.customerName}
                    </Typography>
                  </Stack>
                  {showIds && (
                    <Typography
                      color="text.secondary"
                      variant="caption"
                    >
                      {customer.customerId}
                    </Typography>
                  )}
                </>
              }
            >
              {customer?.devices.length > 0 &&
                customer.devices.map((item, index) => (
                  <CustomTreeItem
                    key={item.deviceId}
                    itemId={item.deviceId}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (location.pathname === "/admin") {
                        editViewStateHandler({ siteName: customer.customerName, deviceId: item.deviceId });
                      } else {
                        onSelectDevice(e, item, customer);
                      }
                    }}
                    label={
                      <Stack direction="row" alignItems="center" spacing={1}>
                        {(isAdmin ? selectedDeviceId === item.deviceId : selectedSystems?.some((sys) => sys.deviceId === item.deviceId)) ? (
                          <CircleIcon fontSize="small" color="secondary" />
                        ) : (
                          <CircleOutlinedIcon fontSize="small" color="disabled" />
                        )}
                        <Stack direction="column" alignItems="flex-start">
                          <Typography
                            color={
                              (isAdmin ? selectedDeviceId === item.deviceId : selectedSystems?.some((sys) => sys.deviceId === item.deviceId))
                                ? theme.palette.secondary.main
                                : "inherit"
                            }
                          >
                            {item.deviceName}
                          </Typography>
                          {showIds && (
                            <Typography
                              color={
                                (isAdmin ? selectedDeviceId === item.deviceId : selectedSystems?.some((sys) => sys.deviceId === item.deviceId))
                                  ? theme.palette.secondary.main
                                  : "inherit"
                              }
                              variant="caption"
                            >
                              {item.deviceId}
                            </Typography>
                          )}
                        </Stack>
                      </Stack>
                    }
                  />
                ))}
            </CustomTreeItem>
          ))}
      </SimpleTreeView>
    </Box>
  );

  // if (location.pathname === '/map') {
  //   return (
  //     <Scrollbars
  //       style={{ maxHeight: "85%" }}>
  //       {siteList()}
  //     </Scrollbars>
  //   );
  // } else {
  //   return (
  //     siteList()
  //   );
  // }
};

export default CustomerWithDevicesList;
